import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";

const edition = import.meta.env.VITE_CROPCHECK_EDITION === "pro" ? "pro" : "free";
if (edition === "pro") document.title = "Naumio CropCheck Pro — Offline batch crop workspace";
const { default: App } = edition === "pro"
  ? await import("./ProApp.jsx")
  : await import("./App.jsx");

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
